import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";

const FacebookVideo = ({ v }) => {
  const aspect = v.aspect || 16 / 9;
  const ref = useRef(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const measure = () => ref.current && setW(Math.round(ref.current.offsetWidth));
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);
  const h = Math.round(w / aspect);
  return (
    <div className="flex justify-center bg-black">
      <div ref={ref} className="w-full" style={{ maxWidth: aspect < 1 ? 360 : "100%", aspectRatio: String(aspect) }}>
        {w > 0 && (
          <iframe title={v.title || "Video del taller"} width={w} height={h} style={{ border: 0, display: "block" }} loading="lazy" allowFullScreen scrolling="no"
            src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(v.url)}&show_text=false&width=${w}&height=${h}`}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" data-testid={`fb-video-${v.id}`} />
        )}
      </div>
    </div>
  );
};

export const VideoPlayer = ({ v }) =>
  v.kind === "facebook" ? <FacebookVideo v={v} /> : (
    <div className="flex justify-center bg-black">
      <video controls preload="metadata" playsInline className="block h-auto max-h-[80vh] w-auto max-w-full object-contain" src={`${API}/videos/${v.id}/file`}>
        Tu navegador no puede reproducir este video.
      </video>
    </div>
  );
